import useTranslation from "../../common/translations";
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
export default function Overlay({ open, onClose, children, }) {
    const { t } = useTranslation("site-search");
    useEffect(() => {
        if (!open)
            return;
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prevOverflow;
        };
    }, [open]);
    useEffect(() => {
        if (!open)
            return;
        function onKeyDown(e) {
            if (e.key === "Escape")
                onClose();
        }
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, onClose]);
    if (!open)
        return null;
    return createPortal(<div className="fixed inset-0 z-[9999] bg-black/40">
      <button type="button" aria-label={t("overlay.close_aria")} className="absolute inset-0 w-full h-full cursor-default" onClick={onClose}/>
      <div className="relative h-full w-full bg-white flex flex-col">
        {children}
      </div>
    </div>, document.body);
}
